import { useContext } from 'react';
import { ContextUserProfile } from '../contexts/UserProfileContext';
const useTranslate = text => {
    const { translate } = useContext(ContextUserProfile);
    if (!text) {
        return translate;
    }
    return translate(text);
};

export default useTranslate;
